const ROOT_SELECTOR = '[data-daily-countdown]';

function datePartsInTimeZone(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23'
  }).formatToParts(date);

  return Object.fromEntries(
    parts
      .filter(({ type }) => type !== 'literal')
      .map(({ type, value }) => [type, Number(value)])
  );
}

function timeZoneOffsetMilliseconds(date, timeZone) {
  const parts = datePartsInTimeZone(date, timeZone);
  const dateWithoutMilliseconds = Math.floor(date.getTime() / 1000) * 1000;
  const wallClockAsUtc = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second
  );

  return wallClockAsUtc - dateWithoutMilliseconds;
}

export function nextMidnightInTimeZone(now, timeZone = 'America/New_York') {
  const current = datePartsInTimeZone(now, timeZone);
  const nextLocalMidnightAsUtc = Date.UTC(
    current.year,
    current.month - 1,
    current.day + 1
  );
  const firstGuess = new Date(nextLocalMidnightAsUtc);
  const firstOffset = timeZoneOffsetMilliseconds(firstGuess, timeZone);
  let result = new Date(nextLocalMidnightAsUtc - firstOffset);
  const correctedOffset = timeZoneOffsetMilliseconds(result, timeZone);

  if (correctedOffset !== firstOffset) {
    result = new Date(nextLocalMidnightAsUtc - correctedOffset);
  }

  return result;
}

export function splitCountdown(milliseconds) {
  const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}

function updateCountdown(countdown, now = new Date()) {
  const timeZone = countdown.dataset.timeZone || 'America/New_York';
  const nextMidnight = nextMidnightInTimeZone(now, timeZone);
  const values = splitCountdown(nextMidnight.getTime() - now.getTime());

  countdown.querySelector('[data-countdown-hours]').textContent = values.hours;
  countdown.querySelector('[data-countdown-minutes]').textContent = values.minutes;
  countdown.querySelector('[data-countdown-seconds]').textContent = values.seconds;
}

export function initAnnouncementCountdown(root = document) {
  const countdowns = [];

  if (root.matches?.(ROOT_SELECTOR)) {
    countdowns.push(root);
  }
  countdowns.push(...root.querySelectorAll(ROOT_SELECTOR));

  countdowns.forEach((countdown) => {
    if (countdown.dataset.countdownInitialized === 'true') return;

    countdown.dataset.countdownInitialized = 'true';
    updateCountdown(countdown);
    const intervalId = window.setInterval(() => {
      if (!countdown.isConnected) {
        window.clearInterval(intervalId);
        return;
      }

      updateCountdown(countdown);
    }, 1000);
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAnnouncementCountdown(), { once: true });
  } else {
    initAnnouncementCountdown();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementCountdown(event.target);
  });
}
